import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useCreateFlash, useCurrentUser } from '@hooks';
import { new_session_path } from '@routes';

const ProtectedRoute = () => {
  const location = useLocation();
  const { currentUser } = useCurrentUser(false);
  const redirectUrl = new_session_path({ returning_url: location.pathname });
  const { mutate: createFlashMessage } = useCreateFlash(redirectUrl);

  if (currentUser) {
    return <Outlet />;
  } else {
    createFlashMessage({
      type: 'notice',
      message: 'You must be logged in to access that page',
    });
    return <Navigate to={redirectUrl} />;
  }
};

export default ProtectedRoute;
